import { Seo } from "@/components/Seo";

const LegalShell = ({ title, children }) => (
  <>
    <section className="bg-navy grain relative pt-40 pb-16 md:pt-48 md:pb-20 overflow-hidden">
      <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-8">
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold tracking-tighter text-white">{title}</h1>
      </div>
    </section>
    <section className="bg-white py-20 md:py-24">
      <div className="mx-auto max-w-4xl px-5 sm:px-8 space-y-10">{children}</div>
    </section>
  </>
);

const Block = ({ heading, children }) => (
  <div>
    <h2 className="font-display text-2xl font-semibold text-navy tracking-tight">{heading}</h2>
    <div className="mt-4 text-slate-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Confidentialite() {
  return (
    <LegalShell title="Politique de confidentialité">
      <Seo title="Politique de confidentialité" description="Politique de confidentialité d'Umbo, dans le respect du RGPD." path="/politique-de-confidentialite" />
      <p className="text-lg text-slate-600">Nord VOIP SASU accorde une grande importance à la protection de vos données personnelles, dans le respect du Règlement Général sur la Protection des Données (RGPD).</p>
      <Block heading="Responsable du traitement">
        <p>Le responsable du traitement des données est Nord VOIP SASU, 679 avenue de la République, 59800 Lille — contact@umbocyber.fr.</p>
      </Block>
      <Block heading="Données collectées">
        <p>Nous collectons uniquement les données que vous nous communiquez volontairement via nos formulaires : nom, entreprise, adresse email, numéro de téléphone, nombre de postes et message. Ces informations sont nécessaires pour répondre à votre demande d'échange ou de plaquette.</p>
      </Block>
      <Block heading="Finalité du traitement">
        <p>Vos données sont utilisées exclusivement pour :</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>répondre à vos demandes de contact et d'échange ;</li>
          <li>vous transmettre la plaquette tarifaire lorsque vous en faites la demande ;</li>
          <li>assurer le suivi commercial de votre demande.</li>
        </ul>
        <p>Vos données ne sont jamais vendues ni cédées à des tiers à des fins commerciales.</p>
      </Block>
      <Block heading="Durée de conservation">
        <p>Vos données sont conservées pendant la durée nécessaire au traitement de votre demande, puis archivées ou supprimées conformément aux obligations légales.</p>
      </Block>
      <Block heading="Vos droits">
        <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition au traitement de vos données. Pour exercer ces droits, écrivez-nous à contact@umbocyber.fr.</p>
      </Block>
      <Block heading="Cookies">
        <p>Ce site utilise uniquement des cookies nécessaires à son bon fonctionnement et, sous réserve de votre consentement, des cookies de mesure d'audience. Vous pouvez à tout moment modifier vos préférences via le bandeau de consentement.</p>
        <p>Lorsque vous choisissez un créneau de rendez-vous après une demande d'échange, le calendrier de réservation est fourni par Calendly, qui peut déposer ses propres cookies nécessaires à la prise de rendez-vous.</p>
      </Block>
    </LegalShell>
  );
}
